import ZonaEntregas from '../../../../views/compartedRoutes/Contabilidad/Modulos/ZonaEntregas';
import { formatearFechaAntesDe, formatearFechaCompleta, formatearPrecio } from '../../../../utils/utils';
import React, { useEffect, useState, useMemo } from 'react';
import { EntregasParciales, ServicioAgendado } from '../../../../objetos/objeto_servicio';
import { useContabilidadModel } from '../../../../modelos/Contabilidad/modeloContabilidad';
import { determinarColorInfo } from '../../../../views/compartedRoutes/Contabilidad/CalendarioWidget';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { GeneralRoutes } from '../../../../utils/navigator';
import { obtenerNombreEmpresaReal } from '../../../../config/unificacion';

//toca proramar, servicioPrincipal
//toca programar otros eventos menores
const DialogEntregaModal = ({ abierto, alCerrar, servicio: servicioPlano }) => {

  const esEntregaParcial = servicioPlano?.tipo === 'entregaParcial';
  let nombreEmpresaReal =  obtenerNombreEmpresaReal(servicioPlano?.nombreEmpresa);

  useEffect(() => {
    const manejarEscape = (e) => {
      if (e.key === 'Escape') alCerrar();
    };

    if (abierto) {
      window.addEventListener('keydown', manejarEscape);
      // Bloquear scroll del body cuando está abierto
      document.body.style.overflow = 'hidden';
    }

    return () => {
      window.removeEventListener('keydown', manejarEscape);
      document.body.style.overflow = 'unset';
    };
  }, [abierto, alCerrar]);

  const {
    formDataEntregas,
    setFormDataEntregas,
    handleSaveUpdate,
    updateServicio,
  } = useContabilidadModel();

  const navigate = useNavigate();

  const FilaDetalle = ({ etiqueta, valor, esBadge = false, resaltar = false, icono = null }) => (
    <div className="flex items-start sm:items-center gap-2 py-1">
        <span className="font-medium text-gray-600 min-w-[120px] text-sm">
        {etiqueta}:
        </span>
        
        {esBadge ? (
        <div className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2 shadow-sm cursor-pointer hover:bg-blue-700 transition-colors">
            {icono && <i className={icono}></i>}
            {valor}
        </div>
        ) : (
        <span className={`text-sm ${resaltar ? 'text-blue-600 font-bold text-lg' : 'text-gray-800'}`}>
            {valor}
        </span>
        )}
    </div>
  );

  const servicio = useMemo(() => {
    if (!servicioPlano) return null;
    // Si ya tiene el método, lo devolvemos; si no, lo instanciamos
    return servicioPlano instanceof ServicioAgendado 
      ? servicioPlano 
      : ServicioAgendado.fromJson(servicioPlano);
  }, [servicioPlano]);

  const entregaParcial = useMemo(() => {
  // Solo actuamos si es tipo entregaParcial y existe el objeto interno de entrega
  if (servicioPlano?.tipo !== 'entregaParcial' || !servicioPlano?.entrega) return null;

  // Si ya es una instancia, la usamos; si no, la creamos desde su propiedad específica
  return servicioPlano.entrega instanceof EntregasParciales 
    ? servicioPlano.entrega 
    : EntregasParciales.fromJson(servicioPlano.entrega); 
  }, [servicioPlano]);

  const handleSave = async(field, value) =>{
      const finalupdate = {
        "value" : value,
        "elementId": entregaParcial.id,
      }
      await updateServicio(servicio.codigo,nombreEmpresaReal,field,finalupdate,'array');
  }


  if (!abierto) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={alCerrar} />

      <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-5xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        <div className="flex flex-col md:flex-row h-full">
        
          {/* COLUMNA IZQUIERDA: Info General */}
          <div className="w-full md:w-1/3 bg-gray-50 p-8 border-r border-gray-100">
            <div className="mb-6">
                <span className="text-[10px] uppercase tracking-widest text-blue-500 font-bold">
                   {esEntregaParcial ? 'Detalle de Entrega Parcial' : 'Servicio Principal'}
                </span>
                <h2 className="text-2xl font-black text-gray-800">
                    {esEntregaParcial ? `Ev - ${servicioPlano.identificador}` : `#${servicio?.codigo}`}
                </h2>
            </div>

            <div className="space-y-1">
                {/* Información común */}
                <FilaDetalle etiqueta="Materia" valor={servicio?.materia} />
                <FilaDetalle etiqueta="Cliente" valor={servicio?.cliente} />
                <FilaDetalle etiqueta="Tutor" valor={servicio?.tutor} />

                {/* --- SECCIÓN CONDICIONAL --- */}
                <div className="py-4">
                    <FilaDetalle etiqueta="Cobrado" valor={formatearPrecio(servicio?.preciocobrado)} resaltar />
                    <FilaDetalle etiqueta="Pago Tutor" valor={formatearPrecio(servicio?.preciotutor)} resaltar />
                    <FilaDetalle etiqueta="Utilidad" valor={formatearPrecio(servicio?.getUtilidadNeta())} resaltar />
                </div>

                <FilaDetalle etiqueta="Debe cliente" valor={formatearPrecio(servicio?.getSaldoPendienteCliente())} resaltar />
                <FilaDetalle etiqueta="Nota" valor={servicio.notasContabilidad} resaltar />

                {/* --- ESTADO DE LA ENTREGA DE TUTOR --- */}
                <div className="mt-4 p-3 bg-white rounded-xl border border-gray-200">
                  <p className="text-[10px] text-gray-400 uppercase font-bold mb-1">
                    Estado de Entrega Tutor ({esEntregaParcial ? 'Parcial' : 'Global'})
                  </p>
                  <span className={`text-xs font-bold px-2 py-1 rounded-md ${
                    (esEntregaParcial 
                      ? (entregaParcial.getTrabajoEntregado()) 
                      : servicio?.getTrabajoEntregado()) 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-orange-100 text-orange-700'
                  }`}>
                    {(esEntregaParcial 
                      ? (entregaParcial?.getTrabajoEntregado()) 
                      : servicio?.getTrabajoEntregado()) 
                    ? '✓ COMPLETADO' : ' PENDIENTE'}
                  </span>
                </div>

                {/* --- ESTADO DE LA ENTREGA DE CLIENTE --- */}
                <div className="mt-4 p-3 bg-white rounded-xl border border-gray-200">
                  <p className="text-[10px] text-gray-400 uppercase font-bold mb-1">
                    Estado de Entrega Cliente ({esEntregaParcial ? 'Parcial' : 'Global'})
                  </p>
                  <span className={`text-xs font-bold px-2 py-1 rounded-md ${
                    (esEntregaParcial 
                      ? (servicioPlano?.avisadoCliente || servicioPlano?.entregadoCliente) 
                      : servicio?.getTrabajoEntregadoCliente()) 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-orange-100 text-orange-700'
                  }`}>
                    {(esEntregaParcial 
                      ? (servicioPlano?.avisadoCliente || servicioPlano?.entregadoCliente) 
                      : servicio?.getTrabajoEntregadoCliente()) 
                    ? '✓ COMPLETADO' : ' PENDIENTE'}
                  </span>
                </div>
              
                <button
                  onClick={() => GeneralRoutes.irADetalleServicio(navigate,servicio)}
                  className="w-full flex items-center justify-center gap-2 py-2.5 bg-[#3f309b] text-white rounded-xl text-sm font-bold hover:bg-[#2b1b81] transition-all shadow-md active:scale-95"
                >
                  <CreditCard size={16} />
                  Ver servicio
                </button>

                 <button
                  onClick={() => {
                    
                    const solicitud = {
                      nombreEmpresa : servicio.nombreEmpresa,
                      id : servicio.idsolicitud,
                    }

                    GeneralRoutes.irADetalle(navigate,solicitud);

                  }}
                  className="w-full flex items-center justify-center gap-2 py-2.5 bg-[#3f309b] text-white rounded-xl text-sm font-bold hover:bg-[#2b1b81] transition-all shadow-md active:scale-95"
                >
                  <CreditCard size={16} />
                  Ver Solicitud
                </button>

            </div>
          </div>

          {/* COLUMNA DERECHA: Zona de Entregas (65% del ancho aprox) */}
          <div className="w-full md:w-2/3 p-8 bg-white">
            <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center gap-2">
                <i className="pi pi-box text-blue-500"></i>
                Gestión de Entregas y Archivos
            </h3>
            
            {/* Gestion de entregas */}
            {esEntregaParcial ? (
              // CONTENIDO PARA ENTREGA PARCIAL
              <div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center gap-2">
                  <i className="pi pi- clock text-orange-500"></i>
                  Detalle de Entrega Específica
                </h3>
                
                <div className="bg-orange-50 border border-orange-100 p-6 rounded-2xl">
                  <p className="text-sm text-orange-800">
                    Usted está visualizando los detalles de la entrega: 
                    <span className="font-bold ml-1">{servicioPlano.titulo}</span>
                  </p>
                  {/* Aquí puedes agregar un formulario pequeño o info específica de la entrega */}
                </div>

                {/* Marcar como entregado */}
                 <button
                  onClick={() => {
                    const hoy = new Date();
                    handleSave('entregasTrabajo.entregaClienteFecha',hoy);
                  }}
                  className="w-full flex items-center justify-center gap-2 py-2.5 bg-[#3f309b] text-white rounded-xl text-sm font-bold hover:bg-[#2b1b81] transition-all shadow-md active:scale-95"
                >
                  <CreditCard size={16} />
                  Entregar trabajo
                </button>
                

              </div>
            ) : (
              // CONTENIDO PARA SERVICIO PRINCIPAL (ZONA DE ENTREGAS COMPLETA)
              <div className="min-h-[400px]">
                <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center gap-2">
                  <i className="pi pi-box text-blue-500"></i>
                  Gestión Integral de Entregas y Archivos
                </h3>
                
                <ZonaEntregas 
                  servicio={servicio}
                  handleSave={(field, valor) => handleSaveUpdate(field, valor, servicio)}
                  formData={formDataEntregas}
                  setFormData={setFormDataEntregas}
                />
              </div>
            )}

          </div>

        </div>

        {/* Botón de cerrar X en la esquina */}
        <button 
            onClick={alCerrar}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
      </div>

    </div>
  );

};

export default DialogEntregaModal;